import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { FloorBlockProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    // 统一处理“更多”按钮
    [`& .${prefixCls}-btn-link`]: {
      paddingBlock: 0,
      paddingInline: token.paddingXS,
      height: 'auto',
      fontSize: token.fontSizeSM
    },
    // 统一处理 tabs 样式
    [`& .${prefixCls}-tabs-card`]: {
      [`.${prefixCls}-tabs-nav`]: {
        marginBlockEnd: token.marginXS,
        paddingInline: token.padding,
        backgroundColor: token.colorBgTextHover
      },
      [`.${prefixCls}-tabs-tab`]: {
        border: 'none',
        fontSize: token.fontSizeHeading5,
        [`&:not(.${prefixCls}-tabs-tab-active)`]: {
          backgroundColor: 'transparent'
        }
      },
      [`.${prefixCls}-tabs-tabpane`]: {
        paddingInlineStart: token.paddingSM
      }
    }
  },
  header: {
    flex: 'none',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: token.marginXS,
    paddingBlock: token.paddingXS,
    paddingInline: token.paddingSM,
    borderBottom: `1px solid ${token.blue8}`
  },
  icon: {
    color: token.blue8,
    fontSize: token.fontSizeHeading4
  },
  title: {
    color: token.blue8,
    fontSize: token.fontSizeHeading4
  },
  body: {
    flex: 1,
    backgroundColor: token.colorWhite,
    boxShadow: token.boxShadowTertiary,
    borderEndStartRadius: token.borderRadiusSM,
    borderEndEndRadius: token.borderRadiusSM,
    overflow: 'hidden'
  }
}))

export const FloorBlock = ({
  className,
  style,
  classNames,
  styles: externalStyles,
  icon,
  title,
  extra,
  children
}: PropsWithChildren<FloorBlockProps>) => {
  const { cx, styles } = useStyles()

  return (
    <div className={cx(styles.container, className)} style={style}>
      {title && (
        <div
          style={externalStyles?.header}
          className={cx(
            styles.header,
            classNames?.header,
            'floor-block-header'
          )}
        >
          <span
            className={cx(styles.icon, classNames?.icon, 'floor-block-icon')}
          >
            {icon}
          </span>
          <span
            className={cx(styles.title, classNames?.title, 'floor-block-title')}
          >
            {title}
          </span>
          {extra}
        </div>
      )}
      <div
        className={cx(styles.body, classNames?.body, 'floor-block-body')}
        style={externalStyles?.body}
      >
        {children}
      </div>
    </div>
  )
}
